export enum EvaluationTestRunStatus {
  archived = "archived",
  qa = "qa",
  building = "building",
  stable = "stable",
}

export const EvaluationTestRunStatusLabels = {
  [EvaluationTestRunStatus.archived]: "Archived",
  [EvaluationTestRunStatus.qa]: "QA",
  [EvaluationTestRunStatus.stable]: "Stable",
  [EvaluationTestRunStatus.building]: "Building",
};

export const EvaluationTestRunStatuses = [
  {
    label: EvaluationTestRunStatusLabels[EvaluationTestRunStatus.archived],
    value: EvaluationTestRunStatus.archived,
    description: "No longer valid.",
  },
  {
    label: EvaluationTestRunStatusLabels[EvaluationTestRunStatus.qa],
    value: EvaluationTestRunStatus.qa,
    description:
      "We are gathering more examples to use and validate the criteria.",
  },
  {
    label: EvaluationTestRunStatusLabels[EvaluationTestRunStatus.stable],
    value: EvaluationTestRunStatus.stable,
    description:
      "This has been pushed to production and is live for all users.",
  },
  {
    label: EvaluationTestRunStatusLabels[EvaluationTestRunStatus.building],
    value: EvaluationTestRunStatus.building,
    description:
      "We are still building out the criteria and are still validating the basic structure.",
  },
];
